export class ErrOption<TUnderlyingError = Error> extends Error {
    constructor(
        message: string,
        public cause: TUnderlyingError,
    ) {
        super(message);
    }
}
